import { APP_NAME } from '../../../configuration/constants';

export const METRICS_PREFIX = `services.${APP_NAME}`;
